import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err, isHttpError, ok } from "@nju/result";
import { IRegisterResult } from "./types";
import { serverResponse } from "./validators";

interface IParams {
  email: string;
  password: string;
}

const errors: { [key: number]: { code: string; message: string } } = {
  409: {
    code: "USER_ALREADY_EXISTS",
    message: "User with given email already exists",
  },
  400: {
    code: "INVALID_FIELD",
    message: "Missing or invalid body field(s)",
  },
};

export async function register({
  email,
  password,
}: IParams): Promise<IRegisterResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/users`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
        "x-source": "fw",
      },
      json: {
        email,
        password,
        type: "NJU_CUSTOMER",
      },
    },
  );

  if (result.isError) {
    if (isHttpError(result.err) && errors[result.err.status]) {
      return err(new BasicError(errors[result.err.status]));
    }
    console.log("dsa");
    Bugsnag.notify(result.err);

    return result;
  }

  return ok({
    actionToken: result.value.action_token,
  });
}
